import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Select2Component } from './select2.component';

@NgModule({
  declarations: [
    Select2Component,
  ],
  imports: [
    CommonModule,
  ],
  exports: [Select2Component],
  providers: [],
})
export class Select2Module {
}

